import { render, staticRenderFns } from "./StepsV2.vue?vue&type=template&id=0c027d60"
import script from "./StepsV2.vue?vue&type=script&lang=js"
export * from "./StepsV2.vue?vue&type=script&lang=js"
import style0 from "./StepsV2.vue?vue&type=style&index=0&id=0c027d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports